import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    CssBaseline,
    FormControl,
    FormControlLabel,
    Grid,
    makeStyles,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    TextField,
    Typography,
    withStyles,
    Backdrop,
    CircularProgress,
    LinearProgress,
    Box,
} from '@material-ui/core';
import AppBarComponent from '../../layout/AppBar';
import Hands from './hands.png';
import EnrollGif from './enroll.gif';
import Scrollbar from 'react-scrollbars-custom';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Alert from '@material-ui/lab/Alert';
import { useForm } from 'react-hook-form';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { API_URL } from '../../../utils/setApiUrl.js';
import UsersDataService from '../../../services/UserService';
import UserDataService from '../../../services/UserService';
import DevicesDataService from '../../../services/DeviceService';
import DeviceDataService from '../../../services/DeviceService';
import DeviceUsersService from '../../../services/DeviceUsersService';
import { AutoDisabler, Validate, ValidationGroup } from 'mui-validate';
import { Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Sm25Client } from './sm25/sm25Client.js';
import {
    GD_NEED_FIRST_SWEEP,
    GD_NEED_SECOND_SWEEP,
    GD_NEED_THIRD_SWEEP,
    GD_NEED_RELEASE_FINGER,
    codeName,
} from './sm25/types.js';

const DEALLOCATE_SETTLE_MS = 500;
const BETWEEN_USERS_DELAY_MS = 1000;
const INSERT_TIMEOUT_MS = 15000;
const FREE_SLOT_TIMEOUT_MS = 10000;
const MAX_SLOT_RETRIES = 3;

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        backgroundColor: 'white',
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        background: 'linear-gradient(#006987 0%, #003544 100%)',
        border: 'none',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    card: {
        borderRadius: '8px',
        '& .MuiCardHeader-root': {
            paddingBottom: '0px !important',
            paddingLeft: '10px !important',
        },
    },
    logo: {
        '& .logo-icon': {
            width: '170px',
            margin: theme.spacing(2.5, 6),
            transition: theme.transitions.create(['width'], {
                duration: theme.transitions.duration.shortest,
                easing: theme.transitions.easing.easeInOut,
            }),
        },
    },
    item: props => ({
        height: 40,
        /* width: 'calc(100% - 16px)', */
        borderRadius: '0',
        /* paddingRight: 12, */
        paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
        '&.active': {
            backgroundColor: '#8adc39',
            color: `${theme.palette.secondary.contrastText}!important`,
            pointerEvents: 'none',
            transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit',
            },
            '& .list-item-icon': {
                color: theme.palette.text.icon,
            },
        },
        '& .list-item-icon': {
            marginRight: 16,
            color: theme.palette.text.icon,
        },
        '& .list-item-text': {},
        color: theme.palette.text.icon,
        cursor: 'pointer',
        textDecoration: 'none!important',
    }),
    itemtext: {
        fontSize: '0.8rem',
    },
    icon: {
        color: 'white',
    },
    nested: {
        fontSize: '0.9rem',
        height: 40,
        paddingLeft: theme.spacing(9),
    },
    fingers: {
        borderRadius: '8px',
        height: '400px',
        backgroundImage: `url(${Hands})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '90% auto',
    },
    radioGroup: {
        float: 'right',
        position: 'absolute',
        width: '55rem',
        display: 'inline-block',
        left: '16.7rem',
        marginTop: '-1rem',
    },
    radioGroupLeft: {
        width: '55rem',
        display: 'inline-block',
        left: '17rem',
        marginTop: '-2.3rem',
    },
    '@global': {
        '.MuiInputLabel-outlined.MuiInputLabel-marginDense': {
            marginLeft: '0 !important',
        },
        'div > label': {
            marginLeft: '5px !important',
            marginRight: '5px !important',
        },
        'div > label:nth-of-type(1)': {
            marginLeft: '1.3rem !important',
            marginBottom: '-21rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-8rem !important',
                marginBottom: '-21rem',
            },
        },
        'div > label:nth-of-type(2)': {
            marginLeft: '-0.7rem !important',
            marginBottom: '-7rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-1.6rem !important',
                marginBottom: '-13rem',
            },
        },
        '.MuiIconButton-root.Mui-disabled': {
            color: '#f006',
        },
        '.MuiFormControlLabel-label.Mui-disabled': {
            color: '#f006',
        },
        'div > label:nth-of-type(3)': {
            marginLeft: '1.2rem !important',
            marginBottom: '-3rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-0.7rem !important',
                marginBottom: '-11rem',
            },
        },
        'div > label:nth-of-type(4)': {
            marginLeft: '2rem !important',
            marginBottom: '-6rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-0.3rem !important',
                marginBottom: '-12rem',
            },
        },
        'div > label:nth-of-type(5)': {
            marginLeft: '-0.2rem !important',
            marginBottom: '-12rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-1.2rem !important',
                marginBottom: '-16rem',
            },
        },
        'fieldset > div > label:nth-of-type(5)': {
            marginLeft: '-0.5rem !important',
            marginBottom: '-21rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-1.5rem !important',
                marginBottom: '-21rem',
            },
        },
        'fieldset > div > label:nth-of-type(4)': {
            marginLeft: '1.5rem !important',
            marginBottom: '-7rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-0.6rem !important',
                marginBottom: '-13rem',
            },
        },
        'fieldset > div > label:nth-of-type(3)': {
            marginLeft: '1.5rem !important',
            marginBottom: '-3rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-0.5rem !important',
                marginBottom: '-11rem',
            },
        },
        'fieldset > div > label:nth-of-type(2)': {
            marginLeft: '0rem !important',
            marginBottom: '-6rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-1.2rem !important',
                marginBottom: '-12.5rem',
            },
        },
        'fieldset > div > label:nth-of-type(1)': {
            marginLeft: '0.5rem !important',
            marginBottom: '-12rem',
            [theme.breakpoints.down('md')]: {
                marginLeft: '-1.2rem !important',
                marginBottom: '-16rem',
            },
        },
        'legend > div > label:nth-of-type(1)': {
            marginLeft: '0 !important',
        },
    },
    textField: {
        margin: theme.spacing(0),
        minWidth: '270px',
        maxWidth: '15vw',
    },
    textField1: {
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(-5px, -6px) scale(0.75)',
            marginLeft: '0 !important',
            [theme.breakpoints.down('md')]: {
                transform: 'translate(165%, -6px) scale(0.75)',
            },
        },
        '& .MuiInputLabel-outlined': {
            transform: 'translate(0px, 12px) scale(1)',
            marginLeft: '0 !important',
            [theme.breakpoints.down('md')]: {
                transform: 'translate(0, 12px) scale(1)',
            },
        },
    },
    textField2: {
        '& .MuiInputLabel-outlined': {
            transform: 'translate(0px, 12px) scale(1)',
            [theme.breakpoints.down('md')]: {
                transform: 'translate(0, 12px) scale(1)',
            },
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(-5px, -6px) scale(0.75)',
            [theme.breakpoints.down('md')]: {
                transform: 'translate(145%, -6px) scale(0.75)',
            },
        },
    },
    legend: {
        flexDirection: 'row',
        width: '97%',
        margin: '10px !important',
        marginTop: '15px !important',
        marginBottom: '0 !important',
    },
    legend2: {
        flexDirection: 'row',
        width: '93%',
        margin: '10px !important',
        marginTop: '15px !important',
        marginBottom: '0 !important',
    },
    enrollFields: {
        width: '100% !important',
        '& .MuiInputLabel-outlined': {
            transform: 'translate(0, 12px) scale(1)',
            [theme.breakpoints.down('md')]: {
                transform: '0',
            },
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(-5px, -6px) scale(0.75)',
            [theme.breakpoints.down('md')]: {
                transform: '0',
            },
        },
    },
    cardContent: {
        padding: '8px !important',
        '& .mui-validate__validate-root': {
            width: '95% !important',
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        flexDirection: 'column',
    },
    loadingPanel: {
        backgroundColor: 'rgba(0, 53, 68, 0.96)',
        borderRadius: 12,
        padding: theme.spacing(4),
        minWidth: 320,
        maxWidth: 440,
        textAlign: 'center',
        boxShadow: theme.shadows[10],
    },
    loadingTitle: {
        fontWeight: 600,
        marginTop: theme.spacing(2),
    },
    loadingSubtitle: {
        opacity: 0.9,
        marginTop: theme.spacing(1),
    },
    loadingProgress: {
        width: '100%',
        marginTop: theme.spacing(2.5),
        borderRadius: 4,
        height: 6,
    },
    loadingHint: {
        opacity: 0.75,
        marginTop: theme.spacing(2),
        display: 'block',
    },
}));

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export default function Devices(props) {
    const { t } = useTranslation();
    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });

    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [loadingContext, setLoadingContext] = useState(null);

    // * Users Dropdown Start
    const [users, setUsers] = useState([]);

    useEffect(() => {
        retrieveUsers();
    }, []);

    const retrieveUsers = async () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        try {
            let response;

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                response = await UserDataService.getAll(joinedValues);
            } else if (locData.id === 'all') {
                response = await UserDataService.adminAll();
            }

            if (response) {
                setUsers(response.data);
                // console.log(response.data);
            }
        } catch (e) {
            console.log(e);
        }
    };

    // * Devices Dropdown
    const [devices, setDevices] = useState([]);
    const [enrollers, setEnrollers] = useState([]);

    useEffect(() => {
        retrieveDevices();
    }, []);

    const retrieveDevices = async () => {
        if (hostname === 'billa.biodit.bg') {
            DevicesDataService.adminAll()
                .then(response => {
                    setDevices(response.data);
                })
                .catch(e => {
                    setErrorMessages(['Cannot load devices']);
                    setIserror(true);
                });
        } else {
            const locData = JSON.parse(localStorage.getItem('loc'));

            try {
                let response;

                if (Array.isArray(locData)) {
                    const joinedValues = locData.join(',');
                    response = await DeviceDataService.getAll(joinedValues);
                } else if (locData.id === 'all') {
                    response = await DeviceDataService.adminAll();
                }

                if (response) {
                    setDevices(response.data);
                    // console.log(response.data);
                }
            } catch (e) {
                console.log(e);
            }
        }
    };

    //for error handling
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);

    // * Form Radios
    const [value, setValue] = useState('');
    const handleChange = event => {
        const selectedValue = event.target.value;

        // Enable the selected radio button
        setDisabled({ ...disabled, [selectedValue]: false });
        setValue(selectedValue);
    };

    // Snackbars Start
    const [snackbars, setSnackbars] = useState([]);

    const handleCloseSnackbar = id => {
        setSnackbars(prevSnackbars =>
            prevSnackbars.filter(snackbar => snackbar.id !== id)
        );
    };

    const handleShowSnackbar = (message, severity, duration = 5000) => {
        const id = new Date().getTime();
        const newSnackbar = {
            id,
            message,
            severity,
            duration,
            position: snackbars.length * 55,
        };

        setSnackbars(prevSnackbars => [...prevSnackbars, newSnackbar]);
    };

    const startLoadingOverlay = ({ title, subtitle, hint }) => {
        setLoadingContext({ title, subtitle, hint });
        setIsLoading(true);
    };

    const stopLoadingOverlay = () => {
        setIsLoading(false);
        setLoadingContext(null);
        setLoadingMessage('');
    };
    //Snackbars End

    // ! Enroll Function Start
    const { handleSubmit, errors } = useForm();

    const [enrollMessage, setEnrollMessage] = useState('');
    const [enrollErrorMessage, setEnrollErrorMessage] = useState('');

    const [openModal, setOpenModal] = React.useState(false);

    async function enrollUser(res) {
        setOpenModal(true);

        try {
            // Use the enrollUserValue instead of userValue for enrollment
            const { data, status } = await axios.post(
                `${API_URL}/enroll`,
                {
                    user: enrollUserValue.sap,
                    finger: value,
                    device: enrollValue.mac,
                },
                {
                    validateStatus: () => true,
                    headers: { 'Content-Type': 'application/json' },
                }
            );

            if (status === 200) {
                setOpenModal(false);
                handleShowSnackbar(
                    t('allocation.enroll.enrollSuccess', {
                        name: enrollUserValue.sap,
                    }),
                    'success'
                );
                retrieveUsers();
            } else if (status === 400) {
                setOpenModal(false);
                handleShowSnackbar(
                    t('allocation.enroll.enrollError', {
                        name: enrollUserValue.sap,
                    }),
                    'error'
                );
            } else {
                setOpenModal(false);
                handleShowSnackbar(
                    t('allocation.enroll.generalEnrollError'),
                    'error'
                );
            }

            // console.log(data);
        } catch (error) {
            setOpenModal(false);
            handleShowSnackbar(
                t('allocation.enroll.generalEnrollError'),
                'error'
            );
            // console.log(error.response);
        }
    }

    // ! Enroll Function End

    // * Sidebar SubMenu Function
    const classes = useStyles();

    const [open, setOpen] = React.useState(true);
    const handleClick = () => {
        setOpen(!open);
    };

    // ! Autocomplete for users Start
    const [userValue, setUserValue] = React.useState([]);
    const [userMassValue, setUserMassValue] = React.useState([]);
    const [inputValue, setInputValue] = React.useState('');
    const [userMassInputValue, setUserMassInputValue] = React.useState('');

    // Add separate state for enrollment user
    const [enrollUserValue, setEnrollUserValue] = React.useState(null);
    const [enrollUserInputValue, setEnrollUserInputValue] = React.useState('');

    const [deviceValue, setDeviceValue] = React.useState(devices[0]);
    const [deviceInputValue, setDeviceInputValue] = React.useState('');

    const [enrollValue, setEnrollValue] = React.useState(enrollers[0]);
    const [enrollInputValue, setEnrollInputValue] = React.useState('');
    // ! Autocomplete for users End

    useEffect(() => {
        if (devices.length > 0 && !deviceValue) {
            setDeviceValue(devices[0]);
        }
    }, [devices, deviceValue]);

    useEffect(() => {
        const handleBeforeUnload = event => {
            if (isLoading) {
                event.preventDefault();
                event.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () =>
            window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isLoading]);

    // * Allocate User Device + DB
    const [allocateMessage, setAllocationMessage] = useState('');
    const [allocateErrorMessage, setAllocationErrorMessage] = useState('');

    const [allMessage, setAllMessage] = useState('');

    const [userAllocateValue, setUserAllocateValue] = React.useState(users[0]);
    const [userInputValue, setUserInputValue] = React.useState('');

    const [deviceUsers, setDeviceUsers] = useState([]);

    const [deviceAllocateValue, setDeviceAllocateValue] = React.useState(
        devices[0]
    );
    const [
        deviceAllocateInputValue,
        setDeviceAllocateInputValue,
    ] = React.useState('');

    const hostname = window.location.hostname;

    async function deallocateUserFromDevice(client, user, device) {
        if (hostname === 'billa.biodit.bg') {
            await client.post(
                '/removeUserEverywhere',
                { user: JSON.stringify(user.sap) },
                { timeout: INSERT_TIMEOUT_MS }
            );
            await DeviceUsersService.remove(user.sap);
            await delay(DEALLOCATE_SETTLE_MS);
            return;
        }

        await client.post(
            '/deallocate',
            { user: user.sap, device: device.mac },
            { timeout: INSERT_TIMEOUT_MS }
        );
        await DeviceUsersService.removeFromDevice(user.sap, device.id);
        await delay(DEALLOCATE_SETTLE_MS);
    }

    function reportSingleDeviceAllocationResults(results, userNames, device) {
        const totalUsers = results.length;
        const fullySuccessful = results.filter(r => r.success).length;
        const anyTemplatesSent = results.some(r => r.templatesSent > 0);
        const snackDuration =
            fullySuccessful === totalUsers ? 6000 : 10000;

        if (fullySuccessful === totalUsers && totalUsers > 0) {
            handleShowSnackbar(
                t('allocation.allocate.allocationSuccess', {
                    name: userNames,
                    device: device.name,
                }),
                'success',
                snackDuration
            );
        } else if (fullySuccessful > 0 || anyTemplatesSent) {
            const templatesSent = results.reduce(
                (sum, r) => sum + (r.templatesSent || 0),
                0
            );
            const templatesTotal = results.reduce(
                (sum, r) =>
                    sum +
                    (r.templatesTotal > 0 ? r.templatesTotal : r.templatesSent),
                0
            );
            handleShowSnackbar(
                t('allocation.allocate.allocationPartialSuccess', {
                    name: userNames,
                    device: device.name,
                    successful: fullySuccessful,
                    total: totalUsers,
                    templatesSent,
                    templatesTotal,
                }) ||
                    `Partial success: ${fullySuccessful}/${totalUsers} users sent to ${device.name}. ${templatesSent}/${templatesTotal} fingerprints delivered.`,
                'warning',
                snackDuration
            );
        } else {
            handleShowSnackbar(
                t('allocation.allocate.allocationError', {
                    name: userNames,
                    device: device.name,
                }),
                'error',
                snackDuration
            );
        }
    }

    function reportMassAllocationResults(deviceResults, userNames) {
        const allUserResults = deviceResults.flatMap(
            deviceResult => deviceResult.userResults || []
        );
        const totalUsers = allUserResults.length;
        const fullySuccessful = allUserResults.filter(r => r.success).length;
        const devicesWithUsers = deviceResults.filter(deviceResult =>
            (deviceResult.userResults || []).some(r => r.success)
        ).length;
        const totalDevices = deviceResults.length;
        const snackDuration =
            fullySuccessful === totalUsers && totalUsers > 0 ? 8000 : 10000;

        if (fullySuccessful === totalUsers && totalUsers > 0) {
            handleShowSnackbar(
                t('allocation.massActions.allocationSuccess', {
                    name: userNames,
                }),
                'success',
                snackDuration
            );
        } else if (fullySuccessful > 0) {
            handleShowSnackbar(
                t('allocation.massActions.allocationPartialSuccess', {
                    name: userNames,
                    successful: fullySuccessful,
                    total: totalUsers,
                    deviceSuccess: devicesWithUsers,
                    deviceTotal: totalDevices,
                }),
                'warning',
                snackDuration
            );
        } else {
            handleShowSnackbar(
                t('allocation.massActions.allocationError'),
                'error',
                snackDuration
            );
        }
    }

    async function allocateUser(res) {
        if (res && res.preventDefault) {
            res.preventDefault();
        }

        if (!userValue.length) {
            return;
        }

        if (!deviceValue || !deviceValue.id || !deviceValue.mac) {
            handleShowSnackbar(
                t('allocation.allocate.allocationError', {
                    name: '',
                    device: '',
                }),
                'error'
            );
            return;
        }

        const userNames = userValue.map(user => user.name).join(', ');
        const userCount = userValue.length;

        startLoadingOverlay({
            title: t('allocation.allocate.overlayTitle'),
            subtitle: t('allocation.allocate.overlaySubtitle', {
                count: userCount,
                device: deviceValue.name,
            }),
            hint: t('allocation.allocate.overlayHint'),
        });

        try {
            const client = axios.create({
                baseURL: API_URL,
                timeout: 180000,
            });
            const response = await client.post('/allocateUsersToDevice', {
                deviceId: deviceValue.id,
                userSaps: userValue.map(user => user.sap),
            });

            const results = response.data.userResults || [];
            await retrieveDevices();
            reportSingleDeviceAllocationResults(
                results,
                userNames,
                deviceValue
            );
        } catch (error) {
            console.error('Allocate users error:', error);

            if (
                error.response &&
                error.response.status === 500 &&
                error.response.data &&
                error.response.data.mqttSyncFailed
            ) {
                await retrieveDevices();
                handleShowSnackbar(
                    t('allocation.allocate.mqttSyncFailed', {
                        device: deviceValue.name,
                    }),
                    'warning',
                    12000
                );
                if (error.response.data.userResults) {
                    reportSingleDeviceAllocationResults(
                        error.response.data.userResults,
                        userNames,
                        deviceValue
                    );
                }
            } else {
                handleShowSnackbar(
                    t('allocation.allocate.allocationError', {
                        name: userNames,
                        device: deviceValue.name,
                    }),
                    'error',
                    8000
                );
            }
        } finally {
            stopLoadingOverlay();
        }
    }

    const [deallocateMessage, setDeallocationMessage] = useState('');
    const [deallocateErrorMessage, setDeallocationErrorMessage] = useState('');

    const [userDeallocateValue, setUserDeallocateValue] = React.useState([]);
    const [inputDeallocateValue, setInputDeallocateValue] = React.useState('');

    const [deviceDeallocateValue, setDeviceDeallocateValue] = React.useState(
        devices[0]
    );
    const [
        deviceDeallocateInputValue,
        setDeviceInputDeallocateValue,
    ] = React.useState('');

    const deallocateUser = async () => {
        const userNames = userDeallocateValue.map(user => user.name).join(', ');

        setIsLoading(true);
        setLoadingMessage(t('allocation.deallocate.deallocationMessage'));
        handleShowSnackbar(
            t('allocation.deallocate.deallocationMessage', {
                name: userNames,
                device: deviceDeallocateValue.name,
            }),
            'info'
        );

        try {
            const client = axios.create({ baseURL: API_URL });

            for (const user of userDeallocateValue) {
                const { sap } = user;
                const { mac: device } = deviceDeallocateValue;
                const { id: deviceId } = deviceDeallocateValue;

                const response = await client.post('/deallocate', {
                    user: sap,
                    device,
                });
                const { status } = response;

                if (status === 200) {
                    await DeviceUsersService.removeFromDevice(sap, deviceId);
                }
            }

            setIsLoading(false);
            setLoadingMessage('');

            handleShowSnackbar(
                t('allocation.deallocate.deallocationSuccess', {
                    name: userNames,
                    device: deviceDeallocateValue.name,
                }),
                'success'
            );
        } catch (error) {
            setIsLoading(false);
            setLoadingMessage('');
            handleShowSnackbar(
                t('allocation.deallocate.deallocationError'),
                'error'
            );
            console.error(error);
        }
    };

    // ! USB Enrollment State
    const sm25ClientRef = useRef(null);
    const [usbConnected, setUsbConnected] = useState(false);
    const [usbEnrolling, setUsbEnrolling] = useState(false);
    const [usbDialogOpen, setUsbDialogOpen] = useState(false);
    const [usbGuideStep, setUsbGuideStep] = useState('');
    const [usbProgress, setUsbProgress] = useState(0);
    const [usbError, setUsbError] = useState('');
    const [enrollTab, setEnrollTab] = useState(0);

    const getGuideMessage = useCallback((code) => {
        switch (code) {
            case GD_NEED_FIRST_SWEEP: return t('allocation.usbEnroll.step1');
            case GD_NEED_SECOND_SWEEP: return t('allocation.usbEnroll.step2');
            case GD_NEED_THIRD_SWEEP: return t('allocation.usbEnroll.step3');
            case GD_NEED_RELEASE_FINGER: return t('allocation.usbEnroll.liftFinger');
            default: return codeName(code);
        }
    }, [t]);

    const getGuideProgress = (code) => {
        switch (code) {
            case GD_NEED_FIRST_SWEEP: return 15;
            case GD_NEED_SECOND_SWEEP: return 40;
            case GD_NEED_THIRD_SWEEP: return 65;
            case GD_NEED_RELEASE_FINGER: return 85;
            default: return 0;
        }
    };

    const connectUsbSensor = async () => {
        try {
            if (!sm25ClientRef.current) {
                sm25ClientRef.current = new Sm25Client();
            }
            const client = sm25ClientRef.current;

            client.setDisconnectCallback(() => {
                setUsbConnected(false);
                handleShowSnackbar(t('allocation.usbEnroll.disconnected'), 'warning');
            });

            client.setGuideCallback((code) => {
                setUsbGuideStep(getGuideMessage(code));
                setUsbProgress(getGuideProgress(code));
            });

            await client.connect();

            const testResult = await client.testConnection();
            if (testResult.ret !== 0) {
                await client.disconnect();
                handleShowSnackbar(t('allocation.usbEnroll.testFailed'), 'error');
                return;
            }

            setUsbConnected(true);
            handleShowSnackbar(t('allocation.usbEnroll.connected'), 'success');
        } catch (error) {
            setUsbConnected(false);
            if (error.message && error.message.includes('No port selected')) {
                return; // User cancelled the picker
            }
            handleShowSnackbar(
                t('allocation.usbEnroll.connectError') + ': ' + error.message,
                'error'
            );
        }
    };

    const disconnectUsbSensor = async () => {
        try {
            if (sm25ClientRef.current) {
                await sm25ClientRef.current.disconnect();
            }
            setUsbConnected(false);
            handleShowSnackbar(t('allocation.usbEnroll.disconnectedManual'), 'info');
        } catch (error) {
            setUsbConnected(false);
        }
    };

    // USB enroll uses the shared enrollUserValue + value (finger) state
    const usbEnrollFingerprint = async () => {
        if (!sm25ClientRef.current || !usbConnected) return;
        if (!enrollUserValue || !value) return;

        const client = sm25ClientRef.current;
        setUsbEnrolling(true);
        setUsbDialogOpen(true);
        setUsbGuideStep(t('allocation.usbEnroll.waitingForFinger'));
        setUsbProgress(5);
        setUsbError('');

        try {
            const enrollOk = await client.enrollAndStoreInRam(30000);
            if (!enrollOk) {
                throw new Error(t('allocation.usbEnroll.enrollFailed'));
            }

            setUsbGuideStep(t('allocation.usbEnroll.retrievingTemplate'));
            setUsbProgress(90);

            const templateData = await client.getEnrollData(5000);
            if (!templateData) {
                throw new Error(t('allocation.usbEnroll.templateRetrieveFailed'));
            }

            setUsbGuideStep(t('allocation.usbEnroll.saving'));
            setUsbProgress(95);

            const base64Template = btoa(
                String.fromCharCode.apply(null, templateData)
            );

            const { status } = await axios.post(
                `${API_URL}/usb-enroll`,
                {
                    user: enrollUserValue.sap,
                    finger: value,
                    template: base64Template,
                },
                {
                    validateStatus: () => true,
                    headers: { 'Content-Type': 'application/json' },
                }
            );

            setUsbDialogOpen(false);
            setUsbEnrolling(false);

            if (status === 200) {
                handleShowSnackbar(
                    t('allocation.usbEnroll.success', { name: enrollUserValue.name }),
                    'success'
                );
                handleSelect(enrollUserValue);
                retrieveUsers();
            } else {
                handleShowSnackbar(t('allocation.usbEnroll.saveFailed'), 'error');
            }
        } catch (error) {
            setUsbEnrolling(false);
            setUsbError(error.message || t('allocation.usbEnroll.generalError'));
            if (error.message && error.message.includes('Timeout')) {
                setUsbGuideStep(t('allocation.usbEnroll.timeout'));
            } else {
                setUsbGuideStep(error.message || t('allocation.usbEnroll.generalError'));
            }
            setUsbProgress(0);
        }
    };

    // Cleanup USB connection on unmount
    useEffect(() => {
        return () => {
            if (sm25ClientRef.current && sm25ClientRef.current.isConnected) {
                sm25ClientRef.current.disconnect().catch(() => {});
            }
        };
    }, []);
    // ! USB Enrollment State End

    const [disabled, setDisabled] = useState({
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
    });

    const handleClear = () => {
        // Reset all disabled fingers at once with a new object
        setDisabled({
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false,
            7: false,
            8: false,
            9: false,
            10: false,
        });

        // Also clear the selected value
        setValue('');
    };

    const handleSelect = value => {
        // Only proceed if we have a valid user
        if (value) {
            // Create a fresh disabled state with all fingers enabled
            let newDisabledState = {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                9: false,
                10: false,
            };

            UsersDataService.get(value.sap)
                .then(response => {
                    // Check if user has enrolled fingers
                    if (
                        response.data.enrolledFingers &&
                        response.data.enrolledFingers.length > 0
                    ) {
                        // Mark enrolled fingers as disabled
                        response.data.enrolledFingers.forEach(finger => {
                            if (finger >= 1 && finger <= 10) {
                                newDisabledState[finger] = true;
                            }
                        });
                    }

                    // Set disabled state once after all processing
                    setDisabled(newDisabledState);

                    // Reset the selected radio button if it's disabled
                    if (value && newDisabledState[parseInt(value)]) {
                        setValue('');
                    }
                })
                .catch(e => {
                    // On error, ensure all fingers are enabled
                    setDisabled(newDisabledState);
                    setErrorMessages(['Cannot load user data']);
                    setIserror(true);
                });
        } else {
            // If no user is selected, reset all to enabled
            setDisabled({
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                9: false,
                10: false,
            });
        }
    };

    const [allDevicesMacs, setAllDeviceMacs] = useState([]);
    const [allDevicesIds, setAllDeviceIds] = useState([]);

    async function sendTemplateToDevice(
        client,
        user,
        device,
        templateData,
        templateId
    ) {
        for (let attempt = 0; attempt < MAX_SLOT_RETRIES; attempt++) {
            const slotResponse = await client.post(
                '/freeSlot',
                { device: device.id },
                { timeout: FREE_SLOT_TIMEOUT_MS }
            );
            const slot = slotResponse.data.message;

            if (!slot || slot === 'No available slot found') {
                throw new Error(`No available slot on device ${device.name}`);
            }

            let dbRecordId = null;
            try {
                const { data: dbRecord } = await DeviceUsersService.create({
                    device_id: device.id,
                    user_id: user.sap,
                    slot,
                    template_id: templateId,
                });
                dbRecordId = dbRecord.id;
            } catch (dbError) {
                if (
                    dbError.response &&
                    dbError.response.status === 409
                ) {
                    const conflictData = dbError.response.data || {};
                    const existing = conflictData.existingRecord;
                    const conflictMessage = conflictData.message || '';

                    if (conflictMessage === 'User template already exists on this device') {
                        if (existing && existing.id) {
                            await DeviceUsersService.remove(existing.id);
                        }
                    } else if (conflictMessage === 'Slot already in use on this device') {
                        if (
                            existing &&
                            existing.id &&
                            existing.user_id === user.sap
                        ) {
                            await DeviceUsersService.remove(existing.id);
                        }
                    } else if (existing && existing.user_id === user.sap && existing.id) {
                        await DeviceUsersService.remove(existing.id);
                    }

                    if (attempt < MAX_SLOT_RETRIES - 1) {
                        await delay(200);
                        continue;
                    }
                    throw new Error(
                        `Failed to resolve DB conflict for user ${user.sap} on ${device.name}`
                    );
                }
                throw dbError;
            }

            try {
                await client.post(
                    '/insert',
                    {
                        device: device.mac,
                        slot,
                        user: JSON.stringify(user.sap),
                        pin: user.pin,
                        template: templateData,
                        card: user.card,
                    },
                    { timeout: INSERT_TIMEOUT_MS }
                );
                return { dbRecordId };
            } catch (insertError) {
                if (dbRecordId) {
                    try {
                        await DeviceUsersService.remove(dbRecordId);
                    } catch (cleanupError) {
                        console.error(
                            `Failed to cleanup DB record ${dbRecordId} after insert failure:`,
                            cleanupError
                        );
                    }
                }
                throw insertError;
            }
        }

        throw new Error(
            `Exhausted slot allocation retries for user ${user.sap}`
        );
    }

    async function processUserOnDevice(
        client,
        user,
        device,
        templates,
        retryCount = 0
    ) {
        const MAX_RETRIES = 2;
        let templatesSent = 0;
        let templatesFailed = 0;
        const templatesToSend =
            templates.length === 0 ? [null] : templates;

        for (const template of templatesToSend) {
            const templateId = template ? template.id : null;
            const templateData = template ? template.template : null;

            try {
                await sendTemplateToDevice(
                    client,
                    user,
                    device,
                    templateData,
                    templateId
                );
                templatesSent++;
            } catch (templateError) {
                templatesFailed++;
                console.error(
                    `Failed to send template ${templateId} for user ${user.sap} on ${device.name}:`,
                    templateError
                );
            }
        }

        const expectedCount = templates.length === 0 ? 1 : templates.length;
        const allSucceeded = templatesSent === expectedCount;

        if (templatesSent === 0 && retryCount < MAX_RETRIES) {
            console.warn(
                `Retrying user ${user.sap} on device ${device.name} (attempt ${
                    retryCount + 2
                }/${MAX_RETRIES + 1})`
            );
            try {
                await client.post(
                    '/deallocate',
                    { user: user.sap, device: device.mac },
                    { timeout: INSERT_TIMEOUT_MS }
                );
            } catch (deallocateError) {
                console.warn(
                    `Deallocate before retry failed for user ${user.sap}:`,
                    deallocateError
                );
            }
            try {
                await DeviceUsersService.removeFromDevice(user.sap, device.id);
            } catch (cleanupError) {
                console.warn(
                    `DB cleanup before retry failed for user ${user.sap}:`,
                    cleanupError
                );
            }
            await delay(DEALLOCATE_SETTLE_MS);
            return processUserOnDevice(
                client,
                user,
                device,
                templates,
                retryCount + 1
            );
        }

        return {
            success: allSucceeded,
            device: device.name,
            templatesTotal: templates.length,
            templatesSent,
            templatesFailed,
            error: allSucceeded
                ? undefined
                : `Sent ${templatesSent}/${expectedCount} fingerprint(s) to ${device.name}`,
        };
    }

    async function sendToAll(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }

        if (!userMassValue.length) {
            return;
        }

        if (!devices.length) {
            handleShowSnackbar(
                t('allocation.massActions.allocationError'),
                'error'
            );
            return;
        }

        const userNames = userMassValue.map(user => user.name).join(', ');

        startLoadingOverlay({
            title: t('allocation.massActions.overlayTitle'),
            subtitle: t('allocation.massActions.overlaySubtitle', {
                userCount: userMassValue.length,
                deviceCount: devices.length,
            }),
            hint: t('allocation.allocate.overlayHint'),
        });

        try {
            const client = axios.create({
                baseURL: API_URL,
                timeout: 600000,
            });
            const response = await client.post('/allocateUsersToDevices', {
                userSaps: userMassValue.map(user => user.sap),
                deviceIds: devices.map(device => device.id),
            });

            const { deviceResults } = response.data;

            await retrieveDevices();
            reportMassAllocationResults(deviceResults || [], userNames);
            console.log('SendToAll detailed results:', deviceResults);
        } catch (error) {
            console.error('SendToAll error:', error);
            handleShowSnackbar(
                t('allocation.massActions.allocationError'),
                'error',
                8000
            );
        } finally {
            stopLoadingOverlay();
        }
    }

    function removeFromEverywhere(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }

        if (!userMassValue.length) {
            return;
        }

        const userNames = userMassValue.map(user => user.name).join(', ');

        const client = axios.create({
            baseURL: API_URL,
        });

        setIsLoading(true);
        setLoadingMessage(
            t('allocation.massActions.deallocationMessage', {
                name: userNames,
            })
        );

        try {
            // Process each selected user
            const promises = userMassValue.map(async user => {
                const response = await client.post(`/removeUserEverywhere`, {
                    user: JSON.stringify(user.sap),
                });

                if (response.status === 200) {
                    return DeviceUsersService.remove(user.sap);
                }
                return Promise.reject();
            });

            Promise.all(promises)
                .then(() => {
                    setIsLoading(false);
                    setLoadingMessage('');
                    handleShowSnackbar(
                        t('allocation.massActions.deallocationSuccess', {
                            name: userNames,
                        }),
                        'success'
                    );
                })
                .catch(() => {
                    setIsLoading(false);
                    setLoadingMessage('');
                    handleShowSnackbar(
                        t('allocation.massActions.deallocationError'),
                        'error'
                    );
                });
        } catch (error) {
            setIsLoading(false);
            setLoadingMessage('');
            handleShowSnackbar(
                t('allocation.massActions.deallocationError'),
                'error'
            );
        }
    }

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBarComponent />
            <main className={classes.content}>
                {/* Loading Backdrop */}
                <Backdrop className={classes.backdrop} open={isLoading}>
                    <Box className={classes.loadingPanel}>
                        <CircularProgress color="inherit" size={48} thickness={4} />
                        <Typography variant="h6" className={classes.loadingTitle}>
                            {(loadingContext && loadingContext.title) ||
                                loadingMessage ||
                                t('allocation.allocate.allocatingUsers')}
                        </Typography>
                        {loadingContext && loadingContext.subtitle && (
                            <Typography
                                variant="body2"
                                className={classes.loadingSubtitle}
                            >
                                {loadingContext.subtitle}
                            </Typography>
                        )}
                        <LinearProgress
                            className={classes.loadingProgress}
                            color="secondary"
                        />
                        {((loadingContext && loadingContext.hint) ||
                            loadingMessage) && (
                            <Typography
                                variant="caption"
                                className={classes.loadingHint}
                            >
                                {(loadingContext && loadingContext.hint) ||
                                    t('allocation.allocate.overlayHint')}
                            </Typography>
                        )}
                    </Box>
                </Backdrop>

                {snackbars
                    .slice()
                    .reverse()
                    .map((snackbar, index) => (
                        <Snackbar
                            key={snackbar.id}
                            open={true}
                            autoHideDuration={snackbar.duration || 5000}
                            onClose={() => handleCloseSnackbar(snackbar.id)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            style={{ bottom: `${10 + index * 55}px` }}
                        >
                            <Alert
                                elevation={6}
                                variant="filled"
                                severity={snackbar.severity}
                                onClose={() => handleCloseSnackbar(snackbar.id)}
                            >
                                {snackbar.message}
                            </Alert>
                        </Snackbar>
                    ))}
                <Scrollbar
                    id="RSC-Example"
                    style={{ width: '100%', height: '100%' }}
                >
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth="lg" className={classes.container}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={6}>
                                <Card className={clsx(classes.card)}>
                                    {enrollMessage}
                                    {enrollErrorMessage}
                                    <Tabs
                                        value={enrollTab}
                                        onChange={(e, newTab) => setEnrollTab(newTab)}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        variant="fullWidth"
                                    >
                                        <Tab label={t('allocation.enroll.deviceTab')} />
                                        <Tab label={t('allocation.usbEnroll.usbTab')} />
                                    </Tabs>

                                    {/* Shared employee field */}
                                    <Grid container>
                                        <Grid item xs={enrollTab === 0 ? 6 : 12}>
                                            <FormControl
                                                component="legend"
                                                className={classes.legend}
                                            >
                                                <Autocomplete
                                                    autoSelect
                                                    value={enrollUserValue}
                                                    onChange={(
                                                        event,
                                                        newUserValue,
                                                        reason
                                                    ) => {
                                                        setEnrollUserValue(
                                                            newUserValue
                                                        );
                                                        if (reason === 'clear') {
                                                            handleClear();
                                                        } else {
                                                            handleSelect(
                                                                newUserValue
                                                            );
                                                        }
                                                    }}
                                                    inputValue={
                                                        enrollUserInputValue
                                                    }
                                                    onInputChange={(
                                                        event,
                                                        newInputValue
                                                    ) => {
                                                        setEnrollUserInputValue(
                                                            newInputValue
                                                        );
                                                    }}
                                                    id="auto-select user"
                                                    getOptionLabel={option =>
                                                        option.name +
                                                            ' - ' +
                                                            option.sap || ''
                                                    }
                                                    getOptionSelected={users =>
                                                        users.sap
                                                    }
                                                    options={users}
                                                    classesName={
                                                        classes.textField1
                                                    }
                                                    fullWidth={true}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            label={t(
                                                                'allocation.enroll.employee'
                                                            )}
                                                            required
                                                            fullWidth
                                                            id="fullWidth"
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        {/* Device dropdown - only on Device tab */}
                                        {enrollTab === 0 && (
                                            <Grid item xs={6}>
                                                <FormControl
                                                    component="legend"
                                                    className={classes.legend2}
                                                >
                                                    <Autocomplete
                                                        autoSelect
                                                        value={devices.mac}
                                                        onChange={(
                                                            event,
                                                            newEnrollValue
                                                        ) => {
                                                            setEnrollValue(
                                                                newEnrollValue
                                                            );
                                                        }}
                                                        inputValue={
                                                            enrollInputValue
                                                        }
                                                        onInputChange={(
                                                            event,
                                                            enrollInputValue
                                                        ) => {
                                                            setEnrollInputValue(
                                                                enrollInputValue
                                                            );
                                                        }}
                                                        id="auto-select enroll"
                                                        getOptionLabel={devices =>
                                                            devices.name.toString()
                                                        }
                                                        getOptionSelected={devices =>
                                                            devices.mac
                                                        }
                                                        fullWidth={true}
                                                        options={devices}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                label={t(
                                                                    'allocation.enroll.device'
                                                                )}
                                                                variant="outlined"
                                                                fullWidth
                                                                id="fullWidth"
                                                                size="small"
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {/* USB sensor status - only on USB tab */}
                                        {enrollTab === 1 && (
                                            <Grid item xs={12} style={{ padding: '0 10px' }}>
                                                {!navigator.serial && (
                                                    <Alert severity="warning" style={{ margin: '8px 0' }}>
                                                        {t('allocation.usbEnroll.browserNotSupported')}
                                                    </Alert>
                                                )}
                                                <Alert
                                                    severity={usbConnected ? 'success' : 'info'}
                                                    style={{ margin: '8px 0' }}
                                                    action={
                                                        <Button
                                                            color="inherit"
                                                            size="small"
                                                            onClick={usbConnected ? disconnectUsbSensor : connectUsbSensor}
                                                        >
                                                            {usbConnected
                                                                ? t('allocation.usbEnroll.disconnect')
                                                                : t('allocation.usbEnroll.connect')}
                                                        </Button>
                                                    }
                                                >
                                                    {usbConnected
                                                        ? t('allocation.usbEnroll.sensorConnected')
                                                        : t('allocation.usbEnroll.sensorNotConnected')}
                                                </Alert>
                                            </Grid>
                                        )}
                                    </Grid>

                                    {/* Shared hands/fingers selector */}
                                    <CardContent
                                        className={clsx(classes.fingers)}
                                    >
                                        <FormControl>
                                            <RadioGroup
                                                className={
                                                    classes.radioGroup
                                                }
                                                aria-label="fingers"
                                                name="fingers"
                                                value={value}
                                                onChange={handleChange}
                                            >
                                                {Array.from(
                                                    { length: 5 },
                                                    (_, index) => (
                                                        <FormControlLabel
                                                            key={index + 1}
                                                            value={(
                                                                index + 1
                                                            ).toString()}
                                                            disabled={
                                                                disabled[
                                                                    index +
                                                                        1
                                                                ]
                                                            }
                                                            checked={
                                                                value ===
                                                                (
                                                                    index +
                                                                    1
                                                                ).toString()
                                                            }
                                                            color={'error'}
                                                            control={
                                                                <Radio />
                                                            }
                                                            label={(
                                                                index + 1
                                                            ).toString()}
                                                            labelPlacement="top"
                                                        />
                                                    )
                                                )}
                                            </RadioGroup>
                                        </FormControl>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                className={
                                                    classes.radioGroupLeft
                                                }
                                                aria-label="fingers"
                                                name="fingers"
                                                value={value}
                                                onChange={handleChange}
                                            >
                                                {Array.from(
                                                    { length: 5 },
                                                    (_, index) => (
                                                        <FormControlLabel
                                                            key={index + 6}
                                                            value={(
                                                                index + 6
                                                            ).toString()}
                                                            disabled={
                                                                disabled[
                                                                    index +
                                                                        6
                                                                ]
                                                            }
                                                            checked={
                                                                value ===
                                                                (
                                                                    index +
                                                                    6
                                                                ).toString()
                                                            }
                                                            control={
                                                                <Radio />
                                                            }
                                                            label={(
                                                                index + 6
                                                            ).toString()}
                                                            labelPlacement="top"
                                                        />
                                                    )
                                                )}
                                            </RadioGroup>
                                        </FormControl>
                                    </CardContent>

                                    {/* Tab-specific action buttons */}
                                    <CardActions>
                                        {enrollTab === 0 ? (
                                            <form
                                                onSubmit={handleSubmit(enrollUser)}
                                                name="form"
                                                style={{ display: 'inline' }}
                                            >
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!value}
                                                >
                                                    {t('allocation.enroll.scan')}
                                                </Button>
                                            </form>
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={
                                                    !usbConnected ||
                                                    !enrollUserValue ||
                                                    !value ||
                                                    usbEnrolling
                                                }
                                                onClick={usbEnrollFingerprint}
                                            >
                                                {usbEnrolling
                                                    ? t('allocation.usbEnroll.enrolling')
                                                    : t('allocation.usbEnroll.enrollButton')}
                                            </Button>
                                        )}
                                    </CardActions>
                                </Card>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                {/* <AddUserForm /> */}
                                <ValidationGroup>
                                    <Card className={classes.card}>
                                        {allocateMessage}
                                        {allocateErrorMessage}
                                        <form
                                            id="allocate-single-device-form"
                                            onSubmit={handleSubmit(
                                                allocateUser
                                            )}
                                        >
                                            <CardHeader
                                                titleTypographyProps={{
                                                    variant: 'h6',
                                                }}
                                                title={t(
                                                    'allocation.allocate.title'
                                                )}
                                                style={{
                                                    paddingBottom:
                                                        '0px !important',
                                                }}
                                            />
                                            <CardContent
                                                style={{
                                                    padding: '8px !important',
                                                }}
                                                className={classes.cardContent}
                                            >
                                                <Grid container>
                                                    <Grid item xs={6}>
                                                        <Validate
                                                            name="user"
                                                            required
                                                        >
                                                            <Autocomplete
                                                                multiple
                                                                limitTags={4}
                                                                value={
                                                                    userValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newUserValue
                                                                ) => {
                                                                    setUserValue(
                                                                        newUserValue
                                                                    );
                                                                }}
                                                                inputValue={
                                                                    userInputValue
                                                                }
                                                                onInputChange={(
                                                                    event,
                                                                    userInputValue
                                                                ) => {
                                                                    setUserInputValue(
                                                                        userInputValue
                                                                    );
                                                                }}
                                                                id="allocate-user-select"
                                                                getOptionLabel={option =>
                                                                    option.name +
                                                                        ' - ' +
                                                                        option.sap ||
                                                                    ''
                                                                }
                                                                className={
                                                                    classes.textField
                                                                }
                                                                options={users}
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={t(
                                                                            'allocation.allocate.employee'
                                                                        )}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        style={{
                                                                            marginLeft:
                                                                                '0 !important',
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Validate>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Validate
                                                            name="device"
                                                            required
                                                        >
                                                            <Autocomplete
                                                                autoSelect
                                                                value={
                                                                    deviceValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newDeviceValue
                                                                ) => {
                                                                    setDeviceValue(
                                                                        newDeviceValue
                                                                    );
                                                                }}
                                                                inputValue={
                                                                    deviceInputValue
                                                                }
                                                                onInputChange={(
                                                                    event,
                                                                    newInputValue
                                                                ) => {
                                                                    setDeviceInputValue(
                                                                        newInputValue
                                                                    );
                                                                }}
                                                                id="allocate-device-select"
                                                                getOptionLabel={option =>
                                                                    (option &&
                                                                        option.name) ||
                                                                    ''
                                                                }
                                                                getOptionSelected={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option &&
                                                                    value &&
                                                                    option.mac ===
                                                                        value.mac
                                                                }
                                                                className={
                                                                    classes.textField
                                                                }
                                                                options={
                                                                    devices
                                                                }
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={t(
                                                                            'allocation.allocate.device'
                                                                        )}
                                                                        variant="outlined"
                                                                        size="small"
                                                                    />
                                                                )}
                                                            />
                                                        </Validate>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '8px',
                                                                display: 'flex',
                                                                gap: '8px',
                                                            }}
                                                        >
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={() =>
                                                                    setUserValue(
                                                                        [
                                                                            ...users,
                                                                        ]
                                                                    )
                                                                }
                                                            >
                                                                {t(
                                                                    'allocation.selectAll'
                                                                )}
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={() =>
                                                                    setUserValue(
                                                                        []
                                                                    )
                                                                }
                                                            >
                                                                {t(
                                                                    'allocation.clearAll'
                                                                )}
                                                            </Button>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <CardActions>
                                                <AutoDisabler>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                        className={
                                                            classes.button
                                                        }
                                                    >
                                                        {t(
                                                            'allocation.allocate.send'
                                                        )}
                                                    </Button>
                                                </AutoDisabler>
                                            </CardActions>
                                        </form>
                                    </Card>
                                </ValidationGroup>

                                <ValidationGroup>
                                    <form
                                        id="deallocate-device-form"
                                        onSubmit={handleSubmit(deallocateUser)}
                                    >
                                        <Card
                                            className={classes.card}
                                            style={{ marginTop: '20px' }}
                                        >
                                            {deallocateMessage}
                                            {deallocateErrorMessage}
                                            <CardHeader
                                                titleTypographyProps={{
                                                    variant: 'h6',
                                                }}
                                                title={t(
                                                    'allocation.deallocate.title'
                                                )}
                                                style={{
                                                    paddingBottom:
                                                        '0px !important',
                                                }}
                                            />
                                            <CardContent
                                                style={{
                                                    padding: '8px !important',
                                                }}
                                                className={classes.cardContent}
                                            >
                                                <Grid container>
                                                    <Grid item xs={12} lg={6}>
                                                        <Validate
                                                            name="user"
                                                            required
                                                        >
                                                            <Autocomplete
                                                                multiple
                                                                limitTags={4}
                                                                value={
                                                                    userDeallocateValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newUserValue
                                                                ) => {
                                                                    setUserDeallocateValue(
                                                                        newUserValue
                                                                    );
                                                                }}
                                                                inputValue={
                                                                    inputDeallocateValue
                                                                }
                                                                onInputChange={(
                                                                    event,
                                                                    userInputValue
                                                                ) => {
                                                                    setInputDeallocateValue(
                                                                        userInputValue
                                                                    );
                                                                }}
                                                                id="auto-select user"
                                                                getOptionLabel={option =>
                                                                    option.name +
                                                                        ' - ' +
                                                                        option.sap ||
                                                                    ''
                                                                }
                                                                className={
                                                                    classes.textField
                                                                }
                                                                options={users}
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={t(
                                                                            'allocation.deallocate.employee'
                                                                        )}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        style={{
                                                                            marginLeft:
                                                                                '0 !important',
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Validate>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '8px',
                                                                display: 'flex',
                                                                gap: '8px',
                                                            }}
                                                        >
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={() =>
                                                                    setUserDeallocateValue(
                                                                        [
                                                                            ...users,
                                                                        ]
                                                                    )
                                                                }
                                                            >
                                                                {t(
                                                                    'allocation.selectAll'
                                                                )}
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={() =>
                                                                    setUserDeallocateValue(
                                                                        []
                                                                    )
                                                                }
                                                            >
                                                                {t(
                                                                    'allocation.clearAll'
                                                                )}
                                                            </Button>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12} lg={6}>
                                                        <Validate
                                                            name="device"
                                                            required
                                                        >
                                                            <Autocomplete
                                                                autoSelect
                                                                value={
                                                                    devices.mac
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newDeviceValue
                                                                ) => {
                                                                    setDeviceDeallocateValue(
                                                                        newDeviceValue
                                                                    );
                                                                }}
                                                                inputValue={
                                                                    deviceDeallocateInputValue
                                                                }
                                                                onInputChange={(
                                                                    event,
                                                                    deviceInputValue
                                                                ) => {
                                                                    setDeviceInputDeallocateValue(
                                                                        deviceInputValue
                                                                    );
                                                                }}
                                                                id="auto-select device"
                                                                getOptionLabel={devices =>
                                                                    devices.name.toString()
                                                                }
                                                                getOptionSelected={devices =>
                                                                    devices.mac
                                                                }
                                                                className={
                                                                    classes.textField
                                                                }
                                                                options={
                                                                    devices
                                                                }
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={t(
                                                                            'allocation.deallocate.device'
                                                                        )}
                                                                        variant="outlined"
                                                                        size="small"
                                                                    />
                                                                )}
                                                            />
                                                        </Validate>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <CardActions>
                                                <AutoDisabler>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                        className={
                                                            classes.button
                                                        }
                                                    >
                                                        {t(
                                                            'allocation.deallocate.remove'
                                                        )}
                                                    </Button>
                                                </AutoDisabler>
                                            </CardActions>
                                        </Card>
                                    </form>
                                </ValidationGroup>

                                <ValidationGroup>
                                    <Card
                                        className={classes.card}
                                        style={{ marginTop: '20px' }}
                                    >
                                        <CardHeader
                                            titleTypographyProps={{
                                                variant: 'h6',
                                            }}
                                            title={t(
                                                'allocation.massActions.title'
                                            )}
                                            // subheader={t(
                                            //     'allocation.massActions.subtitle'
                                            // )}
                                        />
                                        {allMessage}
                                        <CardContent
                                            style={{
                                                padding: '8px !important',
                                            }}
                                            className={classes.cardContent}
                                        >
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <Validate
                                                        name="user"
                                                        required
                                                    >
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={4}
                                                            value={userMassValue}
                                                            onChange={(
                                                                event,
                                                                newUserValue
                                                            ) => {
                                                                setUserMassValue(
                                                                    newUserValue
                                                                );
                                                            }}
                                                            inputValue={
                                                                userMassInputValue
                                                            }
                                                            onInputChange={(
                                                                event,
                                                                userInputValue
                                                            ) => {
                                                                setUserMassInputValue(
                                                                    userInputValue
                                                                );
                                                            }}
                                                            id="mass-actions-user-select"
                                                            getOptionLabel={option =>
                                                                option.name +
                                                                    ' - ' +
                                                                    option.sap ||
                                                                ''
                                                            }
                                                            className={
                                                                classes.textField
                                                            }
                                                            options={users}
                                                            renderInput={params => (
                                                                <TextField
                                                                    {...params}
                                                                    label={t(
                                                                        'allocation.massActions.employee'
                                                                    )}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    style={{
                                                                        marginLeft:
                                                                            '0 !important',
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Validate>
                                                    <div
                                                        style={{
                                                            marginTop: '8px',
                                                            display: 'flex',
                                                            gap: '8px',
                                                        }}
                                                    >
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() =>
                                                                setUserMassValue([
                                                                    ...users,
                                                                ])
                                                            }
                                                        >
                                                            {t(
                                                                'allocation.selectAll'
                                                            )}
                                                        </Button>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() =>
                                                                setUserMassValue([])
                                                            }
                                                        >
                                                            {t(
                                                                'allocation.clearAll'
                                                            )}
                                                        </Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions>
                                            <AutoDisabler>
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    onClick={sendToAll}
                                                >
                                                    {t(
                                                        'allocation.massActions.sendToAll'
                                                    )}
                                                </Button>
                                            </AutoDisabler>
                                            <AutoDisabler>
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    color="bad"
                                                    className={classes.button}
                                                    onClick={
                                                        removeFromEverywhere
                                                    }
                                                >
                                                    {t(
                                                        'allocation.massActions.removeFromAll'
                                                    )}
                                                </Button>
                                            </AutoDisabler>
                                        </CardActions>
                                    </Card>
                                </ValidationGroup>
                            </Grid>
                        </Grid>
                        {/* USB Enrollment Progress Dialog */}
                        <Dialog
                            open={usbDialogOpen}
                            maxWidth="sm"
                            fullWidth
                            onClose={() => {
                                if (!usbEnrolling) {
                                    setUsbDialogOpen(false);
                                    setUsbError('');
                                }
                            }}
                        >
                            <MuiDialogTitle>
                                {t('allocation.usbEnroll.dialogTitle')}
                            </MuiDialogTitle>
                            <DialogContent dividers>
                                <Grid
                                    container
                                    direction="column"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    {usbEnrolling && (
                                        <Grid item>
                                            <img
                                                src={EnrollGif}
                                                width="150"
                                                alt="enrolling..."
                                            />
                                        </Grid>
                                    )}
                                    <Grid item style={{ width: '100%' }}>
                                        <Typography
                                            variant="h6"
                                            align="center"
                                            gutterBottom
                                        >
                                            {usbGuideStep}
                                        </Typography>
                                        <Box style={{ width: '100%', marginTop: '16px' }}>
                                            <LinearProgress
                                                variant="determinate"
                                                value={usbProgress}
                                                color={usbError ? 'secondary' : 'primary'}
                                            />
                                        </Box>
                                    </Grid>
                                    {usbError && (
                                        <Grid item style={{ width: '100%' }}>
                                            <Alert severity="error">
                                                {usbError}
                                            </Alert>
                                        </Grid>
                                    )}
                                    {!usbEnrolling && (
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    setUsbDialogOpen(false);
                                                    setUsbError('');
                                                }}
                                            >
                                                {t('allocation.usbEnroll.close')}
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            </DialogContent>
                        </Dialog>

                        {/* MQTT Enrollment Dialog */}
                        <Dialog open={openModal}>
                            <DialogContent dividers>
                                <Grid
                                    container
                                    alignItems="center"
                                    justify="center"
                                >
                                    <Typography
                                        variant="h5"
                                        gutterBottom
                                        align="center"
                                    >
                                        Поставете и повдигнете пръста си 3 пъти
                                        подред за 1 секунда
                                    </Typography>
                                    <img
                                        src={EnrollGif}
                                        width="200"
                                        alt="enrolling..."
                                    />
                                </Grid>
                            </DialogContent>
                        </Dialog>
                    </Container>
                </Scrollbar>
            </main>
        </div>
    );
}
